//
//  ElementDataView.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { ElementDataViewColumn, } from "./SDKElementDataViewColumn";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ElementDataView {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.id;
        this.persistentId = model.persistentId;
        this.name = model.meta.name;
        this.description = (_a = model.meta.description) !== null && _a !== void 0 ? _a : null;
        this.targetElementType = model.targetElementType;
        this.isDefault = model.isDefault;
        this.columns = model.columns.map((c) => new ElementDataViewColumn(c));
    }
}
